var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSharing(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 13,
    fill: "#7591E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 12C17.6562 12 19 10.6562 19 9C19 7.34375 17.6562 6 16 6C14.3438 6 13 7.34375 13 9C13 9.125 13.0063 9.25 13.0219 9.37187L10.0813 10.8406C9.54375 10.3187 8.80938 10 8 10C6.34375 10 5 11.3438 5 13C5 14.6562 6.34375 16 8 16C8.80938 16 9.54375 15.6813 10.0813 15.1594L13.0219 16.6281C13.0063 16.75 13 16.8719 13 17C13 18.6562 14.3438 20 16 20C17.6562 20 19 18.6562 19 17C19 15.3438 17.6562 14 16 14C15.1906 14 14.4563 14.3187 13.9187 14.8406L10.9781 13.3719C10.9938 13.25 11 13.1281 11 13C11 12.8719 10.9938 12.75 10.9781 12.6281L13.9187 11.1594C14.4563 11.6813 15.1906 12 16 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharing);
export default __webpack_public_path__ + "static/media/sharing.b2659a85ab934523851d6414450eac22.svg";
export { ForwardRef as ReactComponent };